// Prevent load spr.js
if (document.getElementsByClassName('template-product').length==0) {
  const insertBeforeElementBackup = Element.prototype.insertBefore
  Element.prototype.insertBefore= function(...args) {   
    if(!args[0].outerHTML || (args[0].outerHTML && args[0].outerHTML.indexOf("spr.js") ==-1))        
    return insertBeforeElementBackup.apply(this,args)
  }
}

// Prevent load font awesome from 3rd party
const appendElementBackup = Element.prototype.appendChild;
Element.prototype.appendChild= function(...args) { 
  if (args[0].nodeName && args[0].nodeName=='SCRIPT' && args[0].src.indexOf('jquery.min.js')!=-1) {
    if (window.SPR!=undefined) {
      $.ajaxSetup({ cache: !0 }),
      SPR.loadjQueryExtentions($),
      $(document).ready(function () {
        SPR.$=jQuery;
    return SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges();
      })
    }
    return ;
  }
  if(!args[0].outerHTML || (args[0].outerHTML && args[0].outerHTML.indexOf("maxcdn.bootstrapcdn.com/font-awesome/4.6.3/css/font-awesome.min.css") ==-1))      
  return appendElementBackup.apply(this,args)
}

if ($('link[href="https://maxcdn.bootstrapcdn.com/font-awesome/4.4.0/css/font-awesome.min.css"]').length>0)
$('link[href="https://maxcdn.bootstrapcdn.com/font-awesome/4.4.0/css/font-awesome.min.css"]').remove()

// Resize Function
var W_width = $(window).width(), W_height = $(window).height();
$(window).on('resize', function () {
  if($(window).width() != W_width || $(window).height() != W_height){
    W_width = $(window).width();
    W_height = $(window).height();
    _initResize();
  }
});
$(window).on('load', function () {
  _initResize();
});

// Filters
function _initResize() {
  //initSwatches();
  $('.filter-refine').off('click');
  $('.filter-overlay, .filter__close, .filter__apply-button').off('click');
  //$('.filter-sort__title').off('click');
  $(document).off('click.resize');
  //$('.filter-sort-overlay').removeClass('filter-sort-overlay--active');
  $('.filters__container').removeClass('filters__container--sticky');
  $('html').removeClass('no-scroll');
  //$('.filter-sort__list').css('display','');
  //$('.filter-sort').off('click');

  // Filters Mobile/Tablet
  if ($(window).width() < 1365) {
    // Filters - Open
    $('.filter-refine').on('click', function () {
      $('.filter').toggleClass('filter--active');
      $('.filters__container').removeClass('filters__container--sticky');
      $('.filter-overlay').addClass('filter-overlay--active');
      $('html').addClass('no-scroll');
      return false;
    });

    // Filter - Close
    $('.filter-overlay, .filter__close, .filter__apply-button').on('click', function () {
      $('.filter').removeClass('filter--active');
      $('.filter-overlay').removeClass('filter-overlay--active');
      $('html').removeClass('no-scroll');
      return false;
    });
  }

  previousScroll = 0;
  headerOrgOffset = 0;
  if ($(window).width() > 1365) {
    if ($('.header').length>0)  headerOrgOffset = $('.header').offset().top + 28;
  } else {
    if ($('.header').length>0)  headerOrgOffset = $('.header').offset().top;
  }
  
};

// Filters All
$(document).ready(function() {
 _initFilter();
});

function _initFilter() {
  // Filter - Accordion
  $('.filter__title').off('click keydown').on('click keydown', function (e) {
    if (e.type === 'click' || e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation(); // Prevents double triggering

      var $this = $(this);
      var $list = $this.next('.filter__list');

      // Toggle active class and ARIA attributes
      if ($list.hasClass('filter__list--active')) {
        $list.removeClass('filter__list--active').slideUp(150);
        $this.removeClass('filter__title--active').attr('aria-expanded', 'false');
      } else {
        // Close other open lists
        $this.closest('.filter__group').siblings().find('.filter__list').removeClass('filter__list--active').slideUp(150);
        $this.closest('.filter__group').siblings().find('.filter__title').removeClass('filter__title--active').attr('aria-expanded', 'false');

        // Open the clicked list
        $list.addClass('filter__list--active').slideDown(150);
        $this.addClass('filter__title--active').attr('aria-expanded', 'true');
      }
    }
  });
}

// Canvas Cart
var dataOffcanvas;
$(document).ready(function() { 
  $( function(){

    $( document ).on( "beforecreate.offcanvas", function( e ){
      dataOffcanvas = $( e.target ).data('offcanvas-component');
    } );

    $( document ).on( "create.offcanvas", function( e ){
      var dataOffcanvas = $( e.target ).data('offcanvas-component');

    } );

    $( document ).on( "clicked.offcanvas-trigger clicked.offcanvas", function( e ){
      var dataBtnText = $( e.target ).text();
    } );

    $( document ).on( "open.offcanvas", function( e ){
      var dataOffcanvasID = $( e.target ).attr('id');
    } );

    $( document ).on( "resizing.offcanvas", function( e ){
      var dataOffcanvasID = $( e.target ).attr('id');
    } );

    $( document ).on( "close.offcanvas", function( e ){
      var dataOffcanvasID = $( e.target ).attr('id');
    } );

    $( document ).on( "destroy.offcanvas", function( e ){
      var dataOffcanvasID = $( e.target ).attr('id');
    } );

    $( '#bottom' ).on( "create.offcanvas", function( e ){
      var api = $(this).data('offcanvas-component');

      $('.js-destroy').on('click', function () {
        api.destroy();
        //$( '#top' ).data('offcanvas-component').destroy();
      });
    } );

    $( '#left' ).offcanvas( {
      modifiers: "left,overlay",
      triggerButton: '.js-offcanvas-trigger-left'
    } );

    $('.js-enhance').on('click', function () {
      $( document ).trigger( "enhance" );
    });

    $( document ).trigger( "enhance" );
    
  });
});

// Set Cookie
function setCookie(cname,cvalue) {
  var d = new Date();
  d.setTime(d.getTime() + (365*24*60*60*1000));
  var expires = "expires=" + d.toGMTString();
  if((typeof cvalue)!="string")   var cvalue_string=JSON.stringify(cvalue);
  else var cvalue_string=cvalue;
  document.cookie = cname + "=" + cvalue_string + ";" + expires + ";path=/";
}

// Get Cookie
function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  } 
}

// Header Sticky
var previousScroll = 0;
var headerOrgOffset =0;
if ($('.header').length>0)  headerOrgOffset =$('.header').offset().top;

$(window).scroll(function () {
  if ($('.header').length>0) {
    var currentScroll = $(this).scrollTop();
    if (currentScroll > headerOrgOffset) {
      if (currentScroll > previousScroll) {
        $('html:not(".no-scroll") .header').removeClass('header--sticky');
      } else {
        $('html:not(".no-scroll") .header').addClass('header--sticky');
      }
    } else {
      $('html:not(".no-scroll") .header').removeClass('header--sticky');
    }
    previousScroll = currentScroll;
  }
});

// Filter Sticky
if ($(".filters")[0]) {
  var previousScrollFilter = 0,
  headerOrgOffsetFilter = $('.filters').offset().top + (-62);

  $(window).scroll(function (e) {
    var currentScrollFilter = $(this).scrollTop();
    if (currentScrollFilter > headerOrgOffsetFilter) {
      if (currentScrollFilter > previousScrollFilter) {
        $('html:not(".no-scroll") .filters__container').removeClass('filters__container--sticky');
      } else {
        $('html:not(".no-scroll") .filters__container').addClass('filters__container--sticky');
      }
    } else {
      $('html:not(".no-scroll") .filters__container').removeClass('filters__container--sticky');
    }
    previousScrollFilter = currentScrollFilter;
  });
}

// Header Search Toggle
$(document).ready(function() {
  $('.header-search__toggle').click(function () {
    $('.header-search__form').toggleClass('header-search__form--visible');
    $('.site-container').toggleClass('site-container--blackout');
    $('.header-search__input').focus();
  });
  $(document).click(function (e) {
    if (!$(e.target).is(".header *")) {
      $('.site-container').removeClass('site-container--blackout');
      $('.header-search__form').removeClass('header-search__form--visible');
    }
  });
});       

// Collection Description Toggle
$(document).ready(function() { 
  $('.collection__description-toggle').off('click').on('click', function () {
    $('.collection__description').toggleClass('collection__description--visible');
    $(this).find('div').toggle();
    return false;
  });
});

// Footer Accordions
$(document).ready(function() { 
  $('.footer-content__accordion-header').off('click').on('click', function () {
    $(this).toggleClass('footer-content__accordion-header--shown');
    $(this).next('.footer-content__accordion-content').slideToggle(200);
    return false;
  });
});

// Currency Converter
$(document).ready(function() { 
  $('.shopify-currency-form select').on('change', function() {
    $(this)
      .parents('form')
      .submit();
  });
});

// Nav Mega Hover
$(".nav__mega .nav__sub-menu").css('display', 'flex').hide();
$(".nav__single .nav__sub-menu").css('display', 'block').hide();
$(".nav__dropdown").on("mouseenter", function (e) {
  if (window.innerWidth > 1279) {
    $('.nav-overlay').stop(!0, !0).delay(250).fadeIn();
    $(this).children(".nav__sub-menu").stop(!0, !0).delay(250).fadeIn();
    $(this).children(".nav__link").children("span").stop(!0, !0).delay(250).fadeIn();
  }
});
$(".nav__dropdown").on("mouseleave", function (e) {
  if (window.innerWidth > 1279) {
    $('.nav-overlay').stop(!0, !0).delay(250).fadeOut();
    $(this).children(".nav__sub-menu").stop(!0, !0).delay(250).fadeOut();
    $(this).children(".nav__link").children("span").stop(!0, !0).delay(250).fadeOut();
  }
});
// Keyboard interaction - only open on Enter
$(".nav__dropdown .nav__link").on("keydown", function (e) {
  if (e.key === "Enter") {
    const $submenu = $(this).closest(".nav__dropdown").children(".nav__sub-menu");
    if ($submenu.is(":visible")) {
      $submenu.stop(true, true).fadeOut(); // Close if already open
      $('.nav-overlay').stop(true, true).fadeOut();
    } else {
      $submenu.stop(true, true).fadeIn(); // Open if closed
      $('.nav-overlay').stop(true, true).fadeIn();
    }
    e.preventDefault(); // Prevent default Enter behavior
  }
});

// Finance Popup - Klarna
$('.product-finance__link--klarna-30').on('click', function () {
  $('.product-finance-popup--klarna-30').addClass('product-finance-popup--active');
  $('html').addClass('noscroll-finance-popup');
});
$('.product-finance__link--klarna').on('click', function () {
  $('.product-finance-popup--klarna').addClass('product-finance-popup--active');
  $('html').addClass('noscroll-finance-popup');
});

// Finance Popup - Clearpay
$('.product-finance__link--clearpay').on('click', function () {
  $('.product-finance-popup--clearpay').addClass('product-finance-popup--active');
  $('html').addClass('noscroll-finance-popup');
});

// Finance Popup - Laybuy
$('.product-finance__link--laybuy').on('click', function () {
  $('.product-finance-popup--laybuy').addClass('product-finance-popup--active');
  $('html').addClass('noscroll-finance-popup');
});

// Finance Popup - Zip
$('.product-finance__link--zip').on('click', function () {
  $('.product-finance-popup--zip').addClass('product-finance-popup--active');
  $('html').addClass('noscroll-finance-popup');
});

// Finance Popup - Close
$('.product-finance-popup__close').on('click', function () {
  $('.product-finance-popup').removeClass('product-finance-popup--active');
  $('html').removeClass('noscroll-finance-popup');
});

$(document).mouseup(function(e) {
  var container = $(".product-finance-popup *");
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    $('.product-finance-popup--active').removeClass('product-finance-popup--active');
    $('html').removeClass('noscroll-finance-popup');
  }
});

// Account Tabs
$('.account .tab').on('click', function () {
  var tab_id = $(this).attr('data-tab');
  $('.account__tab').removeClass('account__tab--active');
  $('.account__content').hide();
  $(this).addClass('account__tab--active');
  $("#"+tab_id).show();
});

// Mobile Nav
$(document).ready(function() { 

  // Clone
  $('.nav__sub-menu').each(function(){
    $(this).clone().addClass('nav__sub-menu--cloned').insertAfter(".header-nav").wrapInner("<div class='nav__sub-menu__wrap'></div>");
  });

  // Open & Close Nav (Mobile) - Click Function
  $('.header-mobile').off('click').on('click', function () {
    $(this).toggleClass('header-mobile--active');
    $('.header-announcements').toggleClass('header-announcements--hide');
    $('.header-nav').toggle();
    $('.header-nav').toggleClass('header-nav--active');
    $('html').toggleClass('no-scroll-mobile-nav');
    $('.mobile-nav-overlay').toggle();
    $('.nav__sub-menu--cloned').removeClass('nav__sub-menu--active');
    $('.nav').removeClass('nav--hidden');
  });

  // Close Nav (Mobile) - Click Function
  $('.mobile-nav-overlay').off('click').on('click', function () {
    $('.header-mobile').removeClass('header-mobile--active');
    $('.header-announcements').removeClass('header-announcements--hide');
    $('.header-nav').hide();
    $('.header-nav').removeClass('header-nav--active');
    $('html').removeClass('no-scroll-mobile-nav');
    $('.mobile-nav-overlay').hide();
    $('.nav').removeClass('nav--hidden');
    $('.nav__sub-menu--cloned').removeClass('nav__sub-menu--active');
  });

  // Open Sub Menu - Click Function
  $('.nav__dropdown .nav__link').off('click').on('click', function (event) {
    if ($(window).width() < 1280) {
      event.preventDefault();
    }
    var id = $(this).attr('id');
    $('.nav__sub-menu').each(function(){
      var dataid = $(this).attr('data-id');
      console.log(dataid);
      if(id == dataid) {
        $(this).addClass('nav__sub-menu--active');
      }
    });
    $('.nav').addClass('nav--hidden');
  });

  // Back Button - Click Function
  $('.nav__sub-menu__back').off('click').on('click', function () {
    $('.nav__sub-menu').removeClass('nav__sub-menu--active');
    $('.nav').removeClass('nav--hidden');
  });

});

// Run Functions
function _checkafterLoadEvents() {
  window.afterLoadWithEvents.forEach(x=> {
    if (x.evt && !$(x.el).is(document)) {
      if ( x.evt==arguments[0].type && $(x.el).is(arguments[0].target)) {
        $(x.el).off(x.evt+'.'+x.f)
          if (typeof(x.f)=='function') {
            setTimeout(x.f,0);
          }
        else {
          window[x.f].apply();
        }
        window.afterLoadWithEvents.splice(window.afterLoadWithEvents.indexOf(x),1);  
      }
    }
    else {
      if (typeof(x.f)=='function') {
        setTimeout(x.f,0);
      }
      else {
       window[x.f].apply();
      }
      window.afterLoadWithEvents.splice(window.afterLoadWithEvents.indexOf(x),1);  
    }  
  });
  if (window.afterLoadWithEvents.length==0) {
    $(window).off('scroll.afterLoad');
  }
}

function register() {
  jQuery('html').removeClass('no-js').addClass('js');
  if (window.ReadyScript) {
    window.ReadyScript.forEach(x=> {
      loadScript(x.s,x.c);
    });
  }
  if (window.afterLoad) {
    window.afterLoad.forEach(x=> {
      if (x.p!=undefined) {
        window[x.f].apply(x.p);      
      }
      else {
        window[x.f].apply();      
      }
    });    
  }
  
  if (window.afterLoadWithEvents) {
    $(window).on('scroll.afterLoad',_checkafterLoadEvents);
    window.afterLoadWithEvents.forEach(x=> {
      if (x.evt) {
        $(x.el).on(x.evt+'.'+x.f,_checkafterLoadEvents)
      }
    });
  }
}
  
$(document).ready(function(){
  register(); 
  if ($('[data-cart-qty]').length>0) {
    $('[data-cart-qty]').on('focusout',function() {
      if (parseInt($(this).data('cart-qty'))!=parseInt($(this).val())) {
        $(this).closest('form').get(0).submit();
      }
    });
  }
});

// Load scripts after page load
function loadScript(sc,callback) {
  if ($.isArray(sc)) {    
    let lc = document.createElement('script'); lc.type = 'text/javascript'; 
    lc.src = sc[0];
    sc.splice(0,1);   
    if (sc.length>0) {
      $(lc).on('load',function() {loadScript(sc,callback)});           ;
    }
    else if (callback!=undefined) {
    $(lc).on('load',function() {window[callback].apply()});   
    }
    document.getElementsByTagName('body')[0].appendChild(lc);
  } else {
    let lc = document.createElement('script'); lc.type = 'text/javascript'; 
    lc.src = sc;
    if (callback!=undefined) {
      $(lc).on('load',function() {window[callback].apply()});   
    }
    document.getElementsByTagName('body')[0].appendChild(lc);
  }
}

// For Theme Editor
document.addEventListener("shopify:section:load", function(event) {
  register();
});

document.addEventListener('lazybeforeunveil', function (e) {
  var bg = e.target.getAttribute('data-bg');
  if (bg) {
    e.target.style.backgroundImage = "url('" + bg + "')";
  }
});

// Product Page LightGallery Popup
if($("#lightgallery").length != 0) {
  lightGallery(document.getElementById('lightgallery'), {
    selector: '.product-images__item-image',
    plugins: [lgZoom, lgThumbnail],
    speed: 500,
    thumbnail: false,
    getCaptionFromTitleOrAlt: false,
    licenseKey: 'C1DB9144-799D4957-B3C1226F-C451F4A3',
    mobileSettings: { 
      controls: true, 
      showCloseIcon: true,
      download: false, 
    }
  });
}

// Gallery Page LightGallery Popup
if($("#lightgallerypage").length != 0) {
  lightGallery(document.getElementById('lightgallerypage'), {
    selector: '.gallery__image-link',
    plugins: [lgZoom, lgThumbnail],
    speed: 500,
    thumbnail: false,
    getCaptionFromTitleOrAlt: true,
    licenseKey: 'C1DB9144-799D4957-B3C1226F-C451F4A3',
    mobileSettings: { 
      controls: true, 
      showCloseIcon: true,
      download: false, 
    }
  });
}

// Swiper Video play and pause
var vids = $("video"); 
$.each(vids, function(){
  this.controls = false; 
}); 
$("video").click(function() {
  if (this.paused) {
    this.play();
  } else {
    this.pause();
  }
});
$("video").bind('stop pause', function(e) {
  console.log("stopped");
  $(this).parent().removeClass('responsive-video--stopped');
});

$("video").bind('play', function(e) {
  console.log("playing");
  $(this).parent().addClass('responsive-video--stopped');
});

// Swiper Slider - Default
if ($('.swiper--default').length > 0) {
  initSwipers();
}
var productImagesSwiper;
function initSwipers() {
  let swiperInstances = [];
  $(".swiper--default").each(function(index, obj){ 
    const $this = $(this);
    if (!$this.hasClass('swiper-initialized')) {
    $this.addClass("swiper-" + index); 
    $this.find(".swiper-pagination").addClass("pagination-" + index);
    $this.find(".swiper-button-prev").addClass("prev-" + index);
    $this.find(".swiper-button-next").addClass("next-" + index);
    $this.prev().find(".swiper-button-prev").addClass("prev-" + index);
    $this.prev().find(".swiper-button-next").addClass("next-" + index); 
    $this.next().find(".swiper-button-prev").addClass("prev-" + index);
    $this.next().find(".swiper-button-next").addClass("next-" + index); 
    $this.find(".swiper-scrollbar").addClass("scrollbar-" + index);

    if($this.hasClass('swiper--autoplay')) {
      $autoplay = { delay: 4000 };
    } else {
      $autoplay = "";
    }

    if($this.hasClass('swiper--snap')) {
      $freemode = false;
    } else {
      $freemode = true;
    }

    if($this.hasClass('swiper--left')) {
      $centre = false;
    } else {
      $centre = true;
    }

    if($this.find(".swiper-pagination").length) {
      $pagination = '.pagination-' + index;
    } else {
      $pagination = null;
    }
    if($this.find(".swiper-pagination--fraction").length) {
      $pagination_type = 'fraction';
    } else {
      $pagination_type = 'bullets';
    }

    if($this.find(".swiper-button-next").length || $this.prev().find(".swiper-button-next").length || $this.next().find(".swiper-button-next").length ) {
      $next = '.next-' + index;
    } else {
      $next = null;
    }

    if($this.find(".swiper-button-prev").length || $this.prev().find(".swiper-button-prev").length || $this.next().find(".swiper-button-prev").length) {
      $prev = '.prev-' + index;
    } else {
      $prev = null;
    }    

    if($this.find(".swiper-scrollbar").length) {
      $scrollbar = '.scrollbar-' + index;
    } else {
      $scrollbar = null;
    }
    swiperInstances[index] = new Swiper(".swiper-" + index, {
      autoplay: $autoplay,
      slidesPerView: 'auto',
      centerInsufficientSlides: $centre,
      navigation: {
        prevEl: $prev,  
        nextEl: $next, 
      },
      pagination: {
        el: $pagination,
        type: $pagination_type,
        clickable: true
      },
      scrollbar: {
        el: $scrollbar,
        draggable: true,
        snapOnRelease: false,
      },
      mousewheel: {
        forceToAxis: true,
      },
      freeMode: {
        enabled: $freemode,
        minimumVelocity: 0,
        momentumBounce: false,
        momentumRatio: 0.5,
        momentumVelocityRatio: 1.5,
      }
    });
    }
  });
  setTimeout(function () {
    for (const slider of swiperInstances) {
      if (slider!=undefined) {
        slider.update();
        if(slider.isLocked == true) {
          var current = $(slider.el).children(".swiper-nav");
          $(current).addClass('swiper-nav--locked');
        }
        slider.on('lock', function () {
          var current = $(slider.el).children(".swiper-nav");
          $(current).addClass('swiper-nav--locked');
        });
        slider.on('unlock', function () {
          var current = $(slider.el).children(".swiper-nav");
          $(current).removeClass('swiper-nav--locked');
        });
        var id = $(slider.el).attr('id');
      }
    }
  }, 50);
}

// Swiper Slider - Product Page
if ($('.swiper--product-images').length > 0) {
  const productThumbsSwiper = new Swiper(".swiper--product-thumbs", {
    slidesPerView: 'auto',
    watchSlidesProgress: true,
  });
  productImagesSwiper = new Swiper(".swiper--product-images", {
    pagination: {
      el: ".swiper-pagination--product-images",
      clickable: true
    },
    navigation: {
      nextEl: ".swiper-button-next--product-images",
      prevEl: ".swiper-button-prev--product-images",
    },
    thumbs: {
      swiper: productThumbsSwiper,
    },
  });
}

// Show Loading Overlay
function loader(isShow) {
  if (isShow) {
    $('.loader').show();
  }
  else {
    $('.loader').hide();
  }
}

// General Accordion
$('.faqs-accordion__title').off('click keypress').on('click keypress', function (event) {
  if (event.type === 'click' || (event.type === 'keypress' && (event.key === 'Enter' || event.keyCode === 13))) {
    if ($(this).hasClass('active')) {
      $('.faqs-accordion__title').next().slideUp();
      $('.faqs-accordion__title').removeClass('active');
      $('.faqs-accordion__title').attr('aria-expanded', 'false');
    } else {
      $('.faqs-accordion__title').attr('aria-expanded', 'false');
      $('.faqs-accordion__title').removeClass('active');
      $('.faqs-accordion__title').next().slideUp();
      $(this).next().slideDown();
      $(this).addClass('active');
      $(this).attr('aria-expanded', 'true');
    }
  }
});

// Product Accordion
$('.product-accordion__title').off('click keypress').on('click keypress', function (event) {
  if (event.type === 'click' || (event.type === 'keypress' && (event.key === 'Enter' || event.keyCode === 13))) {
    if($(this).hasClass('active')) {
      $('.product-accordion__title').next().slideUp();
      $('.product-accordion__title').removeClass('active');
      $('.product-accordion__title').attr('aria-expanded','false');
    } else {
      $('.product-accordion__title').attr('aria-expanded','false');
      $('.product-accordion__title').removeClass('active');
      $('.product-accordion__title').next().slideUp();
      $(this).next().slideDown();
      $(this).addClass('active');
      $(this).attr('aria-expanded','true');
    }
  }
});

// Cart Discount
function updateCartDiscount(discountCode) {
  const cartId=getCookie('cart') ? `gid://shopify/Cart/${getCookie('cart')}` : '';
  if (cartId != '' )  {
    const _var={
      cartId:cartId,
      discountCodes:discountCode
    };
    FetchDataWithVariables(`
      mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]) {
        cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
          cart {
            id
            discountCodes {
              code
            }
          }
          userErrors {
            field
            message
          }
        }
      }
      `,_var,function(data) {
        _updateCartContent(discountCode!=''?true:false);
      }
    );
  }
}

document.querySelectorAll('[data-action="discountcode"]').forEach(element => {
  element.addEventListener('click',function() {
    updateCartDiscount(document.querySelector('[data-discountcode]').value);
  });
});

document.querySelectorAll('[data-action="discountremove"]').forEach(element => {
  element.addEventListener('click',function() {
    updateCartDiscount('');
    $('#discount').val('');
  });
});

// Product Page - Qty Buttons
// $(document).ready(function () {
//   $('.product-add__quantity-add').on('click', function () {
//     const $input = $(this).siblings('[data-quantity-input]');
//     const currentVal = parseInt($input.val()) || 1;
//     $input.val(currentVal + 1).change();
//   });

//   $('.product-add__quantity-minus').on('click', function () {
//     const $input = $(this).siblings('[data-quantity-input]');
//     const currentVal = parseInt($input.val()) || 1;
//     if (currentVal > 1) {
//       $input.val(currentVal - 1).change();
//     }
//   });
// });

// Hero Text Banner - Delayed Video (On mousemove)
var videoPlayer = document.getElementById('vbanner');
if(videoPlayer){
  window.afterLoadWithEvents.push(
  {
     f:'_loadVideo',
     evt:'mousemove',
     el: document
   }
  ); 
  function _loadVideo() {
    // Video
    var valSources = document.querySelectorAll('video#vbanner source'),
    valVideo = document.querySelector('video#vbanner'),
    valDataSrc = 'data-src',
    valDataPoster = 'data-poster';

    if(window.innerWidth < 601 ) {
      valDataSrc = 'data-src-mobile';
      valDataPoster = 'data-poster-mobile';
    }

    for(var i = 0; i<valSources.length;i++) {
      valSources[i].setAttribute('src',       valSources[i].getAttribute(valDataSrc) || '');
    }

    valVideo.load();

    videoPlayer.addEventListener("canplaythrough", function() {
      videoPlayer.play();
    });
  }
}

// Hero Text Banner - AutoPlay Video
var videoAuto = document.getElementById('vbannerauto');
if(videoAuto){
  // Video
  var valSources = document.querySelectorAll('video#vbannerauto source'),
  valVideo = document.querySelector('video#vbannerauto'),
  valDataSrc = 'data-src',
  valDataPoster = 'data-poster';

  if(window.innerWidth < 601 ) {
    valDataSrc = 'data-src-mobile';
    valDataPoster = 'data-poster-mobile';
  }

  for(var i = 0; i<valSources.length;i++) {
    valSources[i].setAttribute('src',       valSources[i].getAttribute(valDataSrc) || '');
  }

  valVideo.load();

  videoAuto.addEventListener("canplaythrough", function() {
    videoAuto.play();
  });
}

// Metaobject Swatch Hover Function
function showSwatchData(e,t) {
  const swatch = t!='click'?e.target:e.target.closest('a.swatches__col');
  const productCard = swatch.closest('.product-card');
  const productImage = productCard.querySelector('.product-card__image');
  const productTitle = productCard.querySelector('.product-card__title');
  const productPrice = productCard.querySelector('.product-card__price-current');
  const productComparePrice = productCard.querySelector('.product-card__price-compare');
  const productLink = productCard.querySelector('.product-card__image-link');
  const titleLink = productCard.querySelector('.product-card__title');
  const savingText = productCard.querySelector('.product-card__price-saving');
  const priceContainer = productCard.querySelector('.product-card__price');
  const overlayContainer = productCard.querySelector('.product-card__overlays');
  const ds = t=='mouseenter'?swatch.dataset:(t=='mouseleave'?productCard.dataset:e.target.closest('a.swatches__col').dataset);

  if (t!='click' || !productLink.href.endsWith(ds.productUrl)) {
    e.preventDefault();
  }
  // Update with swatch data
  if (ds.imageUrl) {
    productImage.src = ds.imageUrl;
    productImage.srcset = ds.imageSrcset || '';
  }
  
  if (ds.title) {
    productTitle.textContent = ds.title;
    productTitle.title = ds.title;
  }
  
  if (ds.price) {
    productPrice.textContent = ds.price;
  }

  if (ds.comparePrice && ds.onSale === 'true') {
    savingText.textContent = ds.saving;
    savingText.style.display = 'inline';
  } else {
    savingText.style.display = 'none';
  }
  
  // Handle compare price and sale state
  if (ds.comparePrice && ds.onSale === 'true') {
    productComparePrice.textContent = ds.comparePrice;
    productComparePrice.style.display = 'inline';
    priceContainer.classList.add('product-card__price--on-sale');
  } else {
    productComparePrice.style.display = 'none';
    priceContainer.classList.remove('product-card__price--on-sale');
  }
  
  // Handle overlay
  if (ds.overlays) {
    overlayContainer.innerHTML = ds.overlays;
  } else {
    overlayContainer.innerHTML = "";
  }
  
  // Update links
  if (ds.productUrl) {
    productLink.href = ds.productUrl;
    titleLink.href = ds.productUrl;
  }  
}

// Output Metaobject Swatch Hover Function
document.addEventListener('DOMContentLoaded', function() {
  
  // Desktop Hover
  document.addEventListener('mouseenter', function(e) {
    if (window.innerWidth>1279 && e.target && e.target.classList && e.target.classList.contains('swatches__col') && e.target.closest('.product-card__swatches')) {        
      showSwatchData(e,'mouseenter');        
    }
  }, true);
  document.addEventListener('mouseleave', function(e) {
    if (window.innerWidth>1279 && e.target && e.target.classList && e.target.classList.contains('swatches__col') && e.target.closest('.product-card__swatches')) {        
      showSwatchData(e,'mouseleave');  
    }
  }, true);

  // Tablet & Mobile Click
  document.addEventListener('click', function(e) {
    if (window.innerWidth < 1280 && e.target && e.target.closest('a.swatches__col') && e.target.closest('.product-card__swatches')) {
      const swatchCol = e.target.closest('a.swatches__col');
      const swatchContainer = swatchCol.closest('.product-card__swatches');

      swatchContainer.querySelectorAll('.swatches__swatch--current').forEach(function(el) {
        el.classList.remove('swatches__swatch--current');
      });

      const swatch = swatchCol.querySelector('.swatches__swatch');
      if (swatch) {
        swatch.classList.add('swatches__swatch--current');
      }

      showSwatchData(e, 'click');
    }
  }, true);

  // Reset on resize
  window.addEventListener('resize', function() {
    if (window.innerWidth >= 1280) {
      document.querySelectorAll('.product-card').forEach(function(card) {
        const swatchContainer = card.querySelector('.product-card__swatches');
        const firstSwatchCol = swatchContainer?.querySelector('a.swatches__col');
        const firstSwatch = firstSwatchCol?.querySelector('.swatches__swatch');

        if (!firstSwatchCol || !firstSwatch) return;

        swatchContainer.querySelectorAll('.swatches__swatch--current').forEach(function(el) {
          el.classList.remove('swatches__swatch--current');
        });

        firstSwatch.classList.add('swatches__swatch--current');

        const fakeEvent = { target: firstSwatchCol, preventDefault: function(){} };
        showSwatchData(fakeEvent, 'click');
      });
    }
  });
});

/********************************************
PHOTOCOPIERS DIRECT
********************************************/

// Featured Collection - Tabs
$('.featured-collection__tab').off('click').on('click', function () {
  var tab = $(this).data('tab');
  $('.featured-collection__tab').removeClass('featured-collection__tab--active');
  //$('.featured-collection__tab-content').hide();
  $('.featured-collection__tab-content').removeClass('featured-collection__tab-content--active');
  $(this).addClass('featured-collection__tab--active');
  //$('#' + tab).show();
  $('#' + tab).addClass('featured-collection__tab-content--active');
});

// Sort by dropdown
$('.filter-sort').off('click keydown').on('click keydown', function (event) {
  if (event.type === 'click' || event.key === 'Enter') {
    event.preventDefault();
    var $this = $(this);
    if ($this.find('.filter-sort__title').hasClass('filter-sort__title--active')) {
      $this.find('.filter-sort__title').attr('aria-expanded','false');
      $this.find('.filter-sort__title').removeClass('filter-sort__title--active');
      $this.find('.filter-sort__list').removeClass('filter-sort__list--active');
      $this.find('.filter-sort__list').slideUp(200);
    } else {
      $this.find('.filter-sort__title').addClass('filter-sort__title--active');
      $this.find('.filter-sort__title').attr('aria-expanded','true');
      $this.find('.filter-sort__list').addClass('filter-sort__list--active');
      $this.find('.filter-sort__list').slideDown(200);
    }
  }
});

// Filter View Option
$('.filter-view__option').off('click').on('click keydown', function (e) {
  if (e.type === 'click' || (e.type === 'keydown' && e.key === 'Enter')) {
    $('.filter-view__option').removeClass('filter-view__option--active');
    $(this).addClass('filter-view__option--active');
    
    if ($(this).hasClass('filter-view__option--list')) {
      $('.collection__products').addClass('collection__products--list');
      $('.collection__products').removeClass('collection__products--grid');
    } else {
      $('.collection__products').removeClass('collection__products--list');
      $('.collection__products').addClass('collection__products--grid');
    }
  }
});

// Product Radios
$('#subscription_radio').on('change', function () {
  $('.product-main__radio-content').slideUp();
  $('#purchase_subscription').slideDown();
});
$('#rental_radio').on('change', function () {
  $('.product-main__radio-content').slideUp();
  $('#purchase_rental').slideDown();
});
$('#buy_radio').on('change', function () {
  $('.product-main__radio-content').slideUp();
  $('#purchase_buy').slideDown();
});

// Scroll to Search
$(".scroll-to-search").click(function(event) {
  event.preventDefault(); // Prevent default link behavior
  $("html, body").animate({ scrollTop: 0 }, "slow", function() {
    $(".header-search__input").val("").focus(); // Clear input and focus
  });
});

// Popup - Open
$('[data-popup]').off('click keydown').on('click keydown', function (event) {
  if (event.type === 'click' || event.key === 'Enter') {
    var popup = $(this).attr("data-popup");
    $('#popup-' + popup).addClass('popup--active');
    $('html').addClass('no-scroll-popup');
  }
});

// Popup - Close
$('.popup__close').off('click keydown').on('click keydown', function (event) {
  if (event.type === 'click' || event.key === 'Enter') {
    $('.popup').removeClass('popup--active');
    $('html').removeClass('no-scroll-popup');
  }
});

// Popup - Close Outside Panel
$('.popup__panel').click(function(event) {
  event.stopPropagation(); // Prevent the click event from reaching .popup
});
$('.popup').click(function() {
  $('.popup').removeClass('popup--active');
  $('html').removeClass('no-scroll-popup');
});

// Tabbed Content
$('.tabbed-content__tab').off('click').on('click', function () {
  var id = $(this).attr('data-id');
  $('.tabbed-content__tab').removeClass('tabbed-content__tab--active');
  $('.tabbed-content__panel').hide();
  $('#' + id).show();
  $(this).addClass('tabbed-content__tab--active');
});

// Open Chat
function openGorgiasChat() {
  if (window.GorgiasChat) {
    window.GorgiasChat.open();
  } else {
    setTimeout(openGorgiasChat, 300);
  }
}
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".open-chat").forEach(function (button) {
    button.addEventListener("click", openGorgiasChat);
  });
});
